import { Link, Outlet } from "react-router-dom";
import Analytics from "../components/googleAnalytics";


const Layout = () => (
  <>
    <Outlet />
    {import.meta.env.PROD &&
    // Must be last so document.title can be set in any <Outlets />
      <Analytics />
    }
  </>
);

export default Layout;